module.exports = __webpack_public_path__ + "img/level_two_hover.b9bd6022.png";